<template>
  <div class="block-content">
    <div
      v-if="!show"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div
      v-if="show"
      class="tabs is-toggle is-fullwidth"
    >
      <ul>
        <li
          v-for="(tab, tabindex) in tabs"
          :key="`${tabindex}-${tab.name}`"
          :class="{'is-active': tab.name === activeTab.name}"
          @click="switchTab(tab.name)"
        >
          <a>{{ tab.tablabel }}</a>
        </li>
      </ul>
    </div>
    <div class="columns tab-content">
      <div class="column is-12">
        <div
          v-if="show"
          class="is-flex flex-wrap justify-content-center-touch"
        >
          <div
            v-if="show"
            class="is-flex justify-content-center-touch mb-2"
          >
            <div
              v-if="show"
              class="is-flex align-center"
            >
              <strong style="margin-right: 1rem;">Filter:</strong>
              <div
                class="dropdown"
                :class="{'is-active': isActive}"
                @click="isActive = !isActive"
              >
                <div class="dropdown-trigger">
                  <button
                    class="button"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                  >
                    <span>{{ activeRegion }}</span>
                    <span class="icon is-small">
                      <i
                        class="far fa-angle-down"
                        aria-hidden="true"
                      />
                    </span>
                  </button>
                </div>
                <div
                  class="dropdown-menu is-fullwidth"
                  role="menu"
                >
                  <div class="dropdown-content">
                    <a
                      v-for="(region, regindex) in regions"
                      :key="`${regindex}-${region}`"
                      class="navbar-item"
                      @click="switchRegion(region)"
                    >{{ region }}</a>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="show"
              class="is-flex align-center ml-4"
            >
              <div
                class="dropdown"
                :class="{'is-active': isActiveStyle}"
                @click="isActiveStyle = !isActiveStyle"
              >
                <div class="dropdown-trigger">
                  <button
                    class="button"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                  >
                    <span>Style</span>
                    <span class="icon is-small">
                      <i
                        class="far fa-angle-down"
                        aria-hidden="true"
                      />
                    </span>
                  </button>
                </div>
                <div
                  class="dropdown-menu is-fullwidth"
                  role="menu"
                >
                  <div class="dropdown-content">
                    <a
                      class="navbar-item"
                      @click="styleGrid = false"
                    >List</a>
                    <a
                      class="navbar-item"
                      @click="styleGrid = true"
                    >Grid</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="is-flex align-center ml-2 mb-2">
            <div class="field">
              <input
                v-if="show"
                v-model="search"
                class="input"
                placeholder="Find a player"
              >
            </div>
          </div>
          <div
            class="column is-flex is-pulled-right ml-2 mb-2"
            style="justify-content:flex-end"
          >
            <!--<strong style="margin-right:1rem">Game Type:</strong>
            <v-select
                    v-model="tournamentType"
                    :options="tournamentTypes"
                    label="name"
            />-->
            <!--<toggle-button
              ref="tournamentType"
              v-model="tournamentType"
              :width="150"
              :height="30"
              :speed="480"
              :labels="{checked: 'Texas Hold\'em'}"
              :color="{checked: '#7DCE94', unchecked: '#4267b2'}"
              @change="setTournamentType()"
            />-->
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="show"
      class="columns"
    >
      <div class="column is-12">
        <div class="columns">
          <div
            v-if="tabHeaderLabel"
            class="column is-12 text-center"
          >
            <span class="pointHeaderLabel">{{ tabHeaderLabel }}</span>
          </div>
        </div>
        <div
          v-if="show"
          class="columns"
        >
          <div class="column is-12">
            <div
              v-if="!styleGrid"
              class="box"
            >
              <transition-group
                name="players-list"
                tag="div"
                :css="false"
                :before-enter="beforeEnter"
                :enter="enter"
                :leave="leave"
              >
                <div
                  v-for="(player, index) in paginatedPlayers()"
                  :key="`${index}-${player['AHL Num']}`"
                  class="border-bottom is-flex flex-row space-between align-center p-1 standingCard relative"
                >
                  <div class="is-flex flex-row align-center justify-content-center-touch">
                    <div
                      class="num text-center"
                      :class="{'num-first': player.position === 1, 'num-second': player.position === 2, 'num-third': player.position === 3}"
                    >
                      {{ player.position }}
                    </div>
                    <div class="ml-4">
                      <router-link
                        :to="{path: `/players/${player['AHL Num']}`}"
                        class="mr-1 is-block"
                      >
                        {{ player.Name }}
                        <small class=" has-text-dark">{{ player['AHL Num'] }}</small>
                      </router-link>

                      <small>
                        <small class="mr-1">Points:</small>
                        <small class="has-text-info">{{ player.Points }}</small>
                      </small>
                    </div>
                  </div>
                  <div class="mobile-block">
                    <router-link
                      :to="{path: `/players/${player['AHL Num']}`}"
                      class="btn-icon tooltip"
                      data-tooltip="View Player Page"
                    >
                      <i class="far fa-address-card" />
                    </router-link>
                    <a
                      class="btn-icon tooltip"
                      data-tooltip="Add to Friends list"
                      @click="addFriend(player['AHL Num'])"
                    >
                      <i class="far fa-user-plus" />
                    </a>
                  </div>
                </div>
              </transition-group>
            </div>
            <div
              v-if="styleGrid"
              class="style-grid"
            >
              <div
                class="column is-12 is-flex"
                style="flex-wrap: wrap;"
              >
                <article
                  v-for="(player, index) in paginatedPlayers()"
                  :key="`${index}-${player['AHL Num']}`"
                  class="box media winner-card"
                >
                  <modale-image
                    :ref="`modal-${index}`"
                    style="display: none"
                    :image="player.memberphoto"
                    @closeModal="closeModal"
                  />
                  <figure class="media-left">
                    <img
                      v-if="!player.memberphoto"
                      src="/images/profile.png"
                      alt="Image"
                      @click="previewImage(index)"
                    >
                    <img
                      v-if="player.memberphoto"
                      :src="player.memberphoto"
                      alt="Image"
                      @click="previewImage(index)"
                    >
                  </figure>
                  <div class="media-content">
                    <div
                      class="content"
                      style="width: 75%;"
                    >
                      <router-link :to="{path: `/players/${player['AHL Num']}`}">
                        <a>{{ player.Name }}</a>
                        <br>
                        <span class="has-text-dark">{{ player['AHL Num'] }}</span>
                      </router-link>
                      <p class="is-size-7">
                        Points:
                        <strong class="has-text-primary is-size-7">{{ player.Points }}</strong>
                      </p>
                    </div>
                    <div
                      class="num absolute text-center"
                      :class="{'num-first': player.position === 1, 'num-second': player.position === 2, 'num-third': player.position === 3}"
                    >
                      {{ player.position }}
                    </div>
                    <div class="mobile-block">
                      <router-link
                        :to="{path: `/players/${player['AHL Num']}`}"
                        class="btn-icon tooltip"
                        data-tooltip="View Player Page"
                      >
                        <i class="far fa-address-card" />
                      </router-link>
                      <a
                        class="btn-icon tooltip"
                        data-tooltip="Add to Friends list"
                        @click="addFriend(player['AHL Num'])"
                      >
                        <i class="far fa-user-plus" />
                      </a>
                    </div>
                  </div>
                </article>
              </div>
            </div>
            <pagination
              :pagination="pagination"
              per-page="50"
              :total="players.length"
              @paginateMinus="paginateMinus"
              @paginatePlus="paginatePlus"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import ModaleImage from '../ModalImage.vue'
  import Pagination from '../helpers/Pagination.vue'
  import Velocity from 'velocity-animate'

  export default {
    name: 'StandingMain',
    components: {
      ModaleImage,
      Pagination
    },
    props: ['token'],
    data() {
      return {
        standing: '',
        players: '',
        search: '',
        show: false,
        tabs: [],
        activeTab: '',
        regions: [
          732,
          733
        ],
        activeType: 'Texas_Holdem',
        tournamentType: true,
        activeRegion: null,
        isActive: false,
        isActiveStyle: false,
        styleGrid: false,
        pagination: 0,
        showPreviewIndex: '',
        tabHeaderLabel: ''
      }
    },
    computed: {
      searchFilter() {
        if (isNaN(+this.search)) return this.players.filter(p => p.Name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
        return this.players.filter(p => p['AHL Num'].indexOf(this.search) !== -1)
      },
    },
    mounted() {
      window.scrollTo(0, 0)
      this.activeType = this.getTournamentType() ? 'Texas_Holdem' : 'Short_Deck'
      this.tournamentType = this.getTournamentType()
      if (this.$route.params.filter) {
        this.activeRegion = this.$route.params.filter
      }
      this.getTabs()
    },
    methods: {
      getTournamentType() {
        switch (this.$route.params.type) {
          case 'Texas_Holdem':
            return true
          case 'Short_Deck':
            return false
          default:
            return true
        }
      },
      previewImage(index) {
        this.showPreviewIndex = index
        if (this.$refs[`modal-${index}`][0].$el.getAttribute('style') === 'display: none;') {
          this.$refs[`modal-${index}`][0].$el.style.display = 'block'
        } else this.$refs[`modal-${index}`][0].$el.style.display = 'none'
      },
      closeModal() {
        this.$refs[`modal-${this.showPreviewIndex}`][0].$el.style.display = 'none'
        this.showPreviewIndex = ''
      },
      getTabs() {
        this.$axios({
          method: 'POST',
          url: `general/points/${this.activeRegion}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.tabs = []
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].type === 'STANDING') {
                this.tabs.push(res.data[i])
              }
            }
            if (this.$route.params.name) {
              let tab = res.data.find(t => t.name === this.$route.params.name)
              this.activeTab = tab
            } else this.activeTab = this.tabs[0]
            // Get players standing
            this.getStanding()
          })
          .catch((error) => {
            console.log(error)
          })
      },
      getStanding() {
        this.show = false
        this.pagination = 0
        this.activeType = this.$route.params.type || 'Texas_Holdem'
        this.$axios({
          method: 'GET',
          url: `general/points/${this.activeRegion}/${this.activeTab.name}/${this.activeType}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
            type: this.$route.params.type
          }
        })
          .then((res) => {
            this.standing = res.data
            this.players = res.data.pointList
            this.tabHeaderLabel = res.data.headerLabel
            this.show = true
            this.activeRegion = res.data.region
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      },
      setTournamentType() {
        let tab = this.activeTab.name
        this.activeType = this.tournamentType ? 'Texas_Holdem' : 'Short_Deck'
        let activeType = this.activeType
        this.$router.push({path: `/standing/${tab}/${activeType}`})
        this.getStanding()
      },
      fullName(player) {
        let arr = player.Name.split(' ')
        if (player.Handle) {
          arr.splice(2, 0, `"${player.Handle}"`)
        }
        return arr.join(' ')
      },
      switchTab(tab) {
        this.activeTab = this.tabs.find(t => t.name === tab)
        this.activeType = this.tournamentType ? 'Texas_Holdem' : 'Short_Deck'
        let activeType = this.activeType
        this.$router.push({path: `/standing/${tab}/${activeType}`})
        this.getStanding()
      },
      switchRegion(region) {
        this.activeRegion = region
        this.getTabs()
      },
      paginatedPlayers() {
        return this.searchFilter.slice(this.pagination, this.pagination + 50)
      },
      paginatePlus() {
        if (this.players.length > (this.pagination + 50)) {
          this.pagination += 50
        }
      },
      paginateMinus() {
        if (this.pagination >= 50) {
          this.pagination -= 50
        }
      },
      addFriend(id) {
        this.$axios({
          method: 'POST',
          url: `member/addfriend/${this.token}/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                error: false,
                showDialog: true,
                message: res.data.message
              })
          })
          .catch((error) => {
            this.$emit('message',
              {
                error: true,
                showDialog: true,
                message: error.response.data.message
              })
          })
      },
//      Transitions
      beforeEnter: function (el) {
        el.style.opacity = 0
        el.style.height = 0
      },
      enter: function (el, done) {
        Velocity(
          el,
          {opacity: 1, height: '1.6em'},
          {complete: done}
        )
      },
      leave: function (el, done) {
        var delay = el.dataset.index * 150
        setTimeout(function () {
          Velocity(
            el,
            {opacity: 0, height: 0},
            {complete: done}
          )
        }, delay)
      },
    }
  }
</script>
